import React, { useState } from "react";

const url = process.env.REACT_APP_API_BASE_GEOSERVER;
function Precipitation() {
  return (
    <div>
      <iframe
        src={`${url}/precipitation.php`}
        width="100%"
        height="1100px"
        style={{ border: "none" }}
        title="Dynamic Iframe"
      />
    </div>
  );
}

export default Precipitation;
